// Router Common
export default [
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: () => import(/* webpackChunkName: "common" */ '../../views/policy/PrivacyPolicy.vue'),
  },
  {
    path: '/preview',
    name: 'preview',
    component: () => import(/* webpackChunkName: "common" */ '../../views/preview/LeaderPreview.vue'),
    hidden: true,
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "error" */ '../../views/error/404.vue'),
    hidden: true,
  },
  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ '../../views/error/UnsupportedUser.vue'),
    hidden: true,
  },
  {
    path: '/test',
    name: 'test',
    component: () => import(/* webpackChunkName: "test" */ '../../views/test/Test.vue'),
  },
];
